import "./SolarChromosphere.module.css";
import NavigationPortal from "@/reusable_sections/Header";
import TheSolarCore from "./sections/TheSolarCore";
import SolarMethodology from "./sections/SolarMethodology";
import ObservatoryFooter from "@/reusable_sections/Footer";
export default function SolarChromospherePage() {
  return <div>
      <NavigationPortal />
      <TheSolarCore />
      <SolarMethodology />
      <ObservatoryFooter />
    </div>;
}